import { Backend } from '../../../api/Backend';
import { FilterState, listFilterType } from '../../../pages/content/listPage/FilterState';
import { ListFilters } from '../../../pages/content/listPage/ListFilters';
import { GlobalSettingsKeys } from '../../../api/models/GlobalSettingsKeys';

export class EpgGuideFilterDataSource {
  private readonly backend: Backend;
  state: FilterState | undefined;
  private pastAndFuture: boolean;
  private filters: listFilterType[];
  constructor(backend: Backend) {
    this.backend = backend;
    this.filters = [listFilterType.day, listFilterType.tag];
    if (backend.globalSettings.boolValue(GlobalSettingsKeys.showAccessibilityIcons)) {
      this.filters.push(listFilterType.accessibility);
    }
    this.pastAndFuture = true;
  }

  componentDescription() {
    return {
      focusable: true,
      type: ListFilters,
      data: this,
      filterState: this.state,
      backend: this.backend,
    };
  }

  load(): Promise<EpgGuideFilterDataSource> {
    return new Promise(resolve => {
      this.state = new FilterState();
      this.filters.forEach(filter => {
        this.state?.add(filter);
      });
      resolve(this);
    });
  }

  isEmpty(): boolean {
    return false;
  }

  height(): number {
    return 60;
  }
}
